import WorkFlow from "./admin/WorkFlow";
import WorkFlowBloc from "./admin/WorkFlowBlo";
import AdminOnOffBoarding from "./admin/MenuOnOffBoarding";
import MantBienvenida from "./admin/MantBienvenida";
import Bienvenida from "./capacitacion/bienvenida";
//import MantWorkFlow from "./admin/workflowEmp";
import WorkFlowCheckList from "./admin/WorkFlowCheckList";
import DashboardOnOfffBoarding from "./responsable/DashboardOnOfffBoarding";
import MonitorOnOffBoarding from "./responsable/MonitorOnOffBoarding";
import Capacitacion from "./capacitacion/capacitacion";
import CapacitacionList from "./capacitacion/capacitaciónList";
import DashboardOnPowerBI from "./powerBI/dashboardOnPowerBI";
import DashboardOffPowerBI from "./powerBI/dashboardOffPowerBI";
import DashboardEncuestaSalida from "./powerBI/dashboardEncuestaSalida";
import WorkFlowTaskList from "./admin/WorkFlowTaskList";

const routes = [
  {
    type: "private",
    path: "/workflow",
    roles: ["administrador"],
    component: WorkFlow,
    exact: true,
  },
  {
    type: "private",
    path: "/workflow-block/:workflowid/:workflowname/:type",
    roles: [
      "administrador",
      "Responsable_OffBoarding",
      "Responsable_OnBoarding",
      "jefe",
      "Responsable_Headcount",
    ],
    component: WorkFlowBloc,
    exact: true,
  },
  {
    type: "private",
    path: "/workflow-checklist/:workflowblockid/:workflowblockname/:workflowid/:type",
    roles: [
      "administrador",
      "Responsable_OffBoarding",
      "Responsable_OnBoarding",
      "jefe",
      "Responsable_Headcount",
    ],
    component: WorkFlowCheckList,
    exact: true,
  },
  {
    type: "private",
    path: "/Administración-On-Off-Boarding",
    roles: ["administrador", "Encargado_Sanciones", "Responsable_Sanciones"],
    component: AdminOnOffBoarding,
    exact: true,
  },
  {
    type: "private",
    path: "/Mantenimiento-Bienvenida",
    roles: ["administrador"],
    component: MantBienvenida,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion/bienvenida/:name/:id/:tipoWorkflow/:type",
    roles: [
      "empleado",
      "administrador",
      "jefe",
      "alta_direccion",
      "Responsable_OffBoarding",
      "Responsable_OnBoarding",
      "Responsable_Headcount",
    ],
    component: Bienvenida,
    exact: true,
  },
  {
    type: "private",
    // path: "/Dashboard/:tipoWorkflow",
    path: "/Indicador/:tipoWorkflow",
    roles: [
      "Responsable_OnBoarding",
      "Responsable_OffBoarding",
      "jefe",
      "administrador",
    ],
    component: DashboardOnOfffBoarding,
    exact: true,
  },
  {
    type: "private",
    path: "/Monitor/:nombre/:tipo",
    roles: [
      "Responsable_OffBoarding",
      "Responsable_OnBoarding",
      "jefe",
      "administrador",
      "Responsable_Headcount",
    ],
    component: MonitorOnOffBoarding,
    exact: true,
    File,
  },
  {
    type: "private",
    path: "/monitorBording/taksListBording/:tipo",
    roles: [
      "Responsable_OffBoarding",
      "Responsable_OnBoarding",
      "jefe",
      "empleado",
      "administrador",
      "Responsable_Headcount",
    ],
    component: WorkFlowTaskList,
    exact: true,
  },

  {
    type: "private",
    path: "/capacitacion/:name/:id/:tipoWorkflow/:type",
    roles: [
      "empleado",
      "administrador",
      "jefe",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: Capacitacion,
    exact: true,
  },
  {
    type: "private",
    path: "/capacitacion/:id/:type",
    roles: [
      "empleado",
      "administrador",
      "jefe",
      "alta_direccion",
      "Responsable_Headcount",
    ],
    component: CapacitacionList,
    exact: true,
  },
  {
    type: "private",
    // path: "/Dashboard-Onboarding-PowerBI",
    path: "/Tablero-Onboarding-PowerBI",
    roles: ["administrador", "alta_direccion", "Responsable_OnBoarding"],
    component: DashboardOnPowerBI,
    exact: true,
  },
  {
    type: "private",
    // path: "/Dashboard-Offboarding-PowerBI",
    path: "/Tablero-Offboarding-PowerBI",
    roles: [
      "administrador",
      "alta_direccion",
      "Responsable_OffBoarding",
      "Responsable_Headcount",
      "Responsable_Sanciones",
      "Encargado_Sanciones",
    ],
    component: DashboardOffPowerBI,
    exact: true,
  },
  {
    type: "private",
    // path: "/Dashboard-Encuestas-de-Salida",
    path: "/Tablero-Encuestas-de-Salida",
    roles: [
      "administrador",
      "alta_direccion",
      "Responsable_OffBoarding",
      "Responsable_Headcount",
    ],
    component: DashboardEncuestaSalida,
    exact: true,
  },
];

export default routes;
